import { RootState } from '@/store/types';
import axios from 'axios';
import { AxiosCacheInstance, setupCache } from 'axios-cache-interceptor';
import Vue from 'vue';
import { Store } from 'vuex';
import { addRequestInterceptors } from './http-interceptors-global';

declare module 'vue/types/vue' {

  interface Vue {
    $customerFormsAxios: AxiosCacheInstance
  }

  interface VueConstructor {
    $customerFormsAxios: AxiosCacheInstance
  }
}

export function CustomerFormsAxios(vueCtor: typeof Vue, store: Store<RootState>): void {
  const axiosInstance = axios.create({
    baseURL: vueCtor.$settings.customerFormsApiUrl,
    headers: {
      "Ocp-Apim-Subscription-Key": vueCtor.$settings.subkey
    }
  })

  const customerFormsAxios = setupCache(axiosInstance, {
    ttl: 60 * 60 * 1000,
    cachePredicate: {
      // No cache by default
      statusCheck: () => false
    },
  })

  addRequestInterceptors(customerFormsAxios, store)

  vueCtor.prototype.$customerFormsAxios = customerFormsAxios
}
